define('modules/form_editor/views/editor_advanced_custom',['require','exports','module','base/view','lib/papaparse','../../editor/models/editorstate'],function(require, exports, module){
  "use strict";
  var BaseView = require("base/view"),
    Csv = require("lib/papaparse"),
    EditorState = require("../../editor/models/editorstate");

  module.exports = BaseView.extend({

    events: {
      "change .js-variable": "updateModel",
      // dropdown
      "change .js-file": "processFile",
      "change .js-invalid-date-message": "updateModel",
      "change .js-invalid-date-agelimit-message": "updateModel",
      "change .js-dropdown-url": "updateModel",
      "change .js-confirmation-different-message": "updateModel"
    },

    initialize: function (options) {
      this.collection = this.model.items;
      this.template = options.template;
    },

    helpers: function() {
      return {
        // isAMP and isPopup
        isAMP: EditorState.getAMPState(),
        isPopup: EditorState.isCurrentStepPopup(),

        // custom date
        invalidDateMessage: this.model.getFormEditorMessage(
          "invalidDateMessage", { label: this.model.get("labelText") }
        ),
        invalidDateAgeLimitMessage: this.model.getFormEditorMessage(
          "invalidDateAgeLimitMessage", { label: this.model.get("labelText"), ageLimit: this.model.get("ageLimit") }
        ),

        // dropdown
        hasUrlLoad: true,
        hasCsvLoad: true,

        // password
        confirmationDifferentMessage: this.model.getFormEditorMessage("confirmationDifferentMessage")
      };
    },

    onRender: function(){
      this.$el.i18n();
    },

    updateModel: function() {
      var domAttrs = {
          variable: ".js-variable",
          invalidDateMessage: ".js-invalid-date-message",
          invalidDateAgeLimitMessage: ".js-invalid-date-agelimit-message",
          url: ".js-dropdown-url",
          confirmationDifferentMessage: ".js-confirmation-different-message"
        },
        modelAttrs = _.reduce(domAttrs, function (modelAttrs, el, attr) {
          var value = this.$(el).val() || '';
          modelAttrs[attr] = value.trim();

          return modelAttrs;
        }, {}, this);
      this.model.set(modelAttrs);
    },

    // dropdown
    processFile: function(e) {
      e.preventDefault();
      var file = e.target.files[0];
      Csv.parse(file, {
        delimiter: "",
        header: false,
        dynamicTyping: true,
        complete: _.bind(this.addItemsFromFile, this),
        error: _.bind(this.showErrorForCsv, this),
        skipEmptyLines: true
      });
    },

    addItemsFromFile: function(result) {
      var options = _.map(result.data, function(option) {
        if (option[3] === undefined) {
          option[3] = true;
        }
        return _.object(["text", "value", "valid"], option);
      });

      this.collection.reset(options, {silent: true});
      this.model.setFirstOptionInvalid(false);
    },

    showErrorForCsv: function(){
      this.$(".js-file").parent().addClass("has-error");
      this.$(".js-error-csv").removeClass("hidden");
    }
  });
});

